import { DataGrid, GridColumnsConfigProvider } from '@finbeat/react-toolkit';
import DataTimeText from 'components/Common/DataTime';
import Money from 'components/Common/Money';
import { LoanProlongations } from 'models/api/order';
import { Trans, useTranslation } from 'react-i18next';
import { Card, CardHeader, FormGroup } from 'reactstrap';

const ProlongationsTable = ({ prolongations }: { prolongations: LoanProlongations[] }) => {
    const { t } = useTranslation();
    return prolongations.length > 0 ? (
        <FormGroup>
            <Card className="card-for-table">
                <CardHeader>{t('BackOfficeProlongations')}</CardHeader>
                <GridColumnsConfigProvider<LoanProlongations>
                    storagePath="payment-covers-grid"
                    initColumns={[
                        {
                            key: 'id',
                            name: <Trans i18nKey="BackOfficeId" />,
                            cellClass: 'base-data-grid__normal-line-height',
                        },
                        {
                            key: 'dt',
                            name: <Trans i18nKey="BackOfficeRenewalStartDate" />,
                            cellClass: 'base-data-grid__normal-line-height',
                            formatter: ({ row }) => <DataTimeText value={row.dt} />,
                        },
                        {
                            key: 'amount',
                            name: <Trans i18nKey="BackOfficeAmount" />,
                            cellClass: 'base-data-grid__normal-line-height',
                            formatter: ({ row }) => <Money value={row.amount} />,
                        },
                        {
                            key: 'term',
                            name: <Trans i18nKey="BackOfficeTerm" />,
                            cellClass: 'base-data-grid__normal-line-height',
                        },
                    ]}
                >
                    <DataGrid<LoanProlongations>
                        rows={prolongations}
                        lineHeight={35}
                        reactDataGreedProps={{
                            defaultColumnOptions: {
                                sortable: true,
                                resizable: true,
                            },
                        }}
                        blockSize={35 + prolongations.length * 35}
                        minBlockSize={90}
                    />
                </GridColumnsConfigProvider>
            </Card>
        </FormGroup>
    ) : (
        <></>
    );
};

export default ProlongationsTable;
